// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const { FETCH_ORG_END_USER_COUNT_DONE } = require('constants/ActionConstants').default

const EndUserCountStore = Marty.createStore({
  id: 'EndUserCountStore',

  getInitialState() {
    return {
      countByStartDate: {}
    }
  },

  handlers: {
    fetchEndUserCountDone: FETCH_ORG_END_USER_COUNT_DONE
  },

  fetchOrgEndUserCount(startDate) {
    const id = `fetchOrgEndUserCount${ startDate }`
    return this.fetch({
      id,
      dependsOn: this.app.stores.OrgStore.getOrFetchCurrentOrg(),
      locally() {
        if (this.hasAlreadyFetched(id)) {
          return this.state.countByStartDate[startDate]
        }
      },
      remotely() {
        const orgId = this.app.stores.OrgStore.getCurrentOrg().id
        return this.app.queries.EndUserQueries.fetchOrgEndUserCount(orgId, startDate)
      }
    })
  },

  fetchEndUserCountDone(count, startDate) {
    let countByStartDate = {}
    countByStartDate[startDate] = count
    countByStartDate = _.assign({}, this.state.countByStartDate, countByStartDate)
    return this.setState({ countByStartDate })
  }
})

export default EndUserCountStore



// WEBPACK FOOTER //
// ./src/scripts/stores/EndUserCountStore.js